import { ReactElement, ComponentType } from 'react';
import { ActivityType } from 'types';
import { CheckField, DatePickerField, IntField, TextField } from '@ff-it/form';
import { FormInline } from 'components';
import { required } from 'utilities';
import { RadioClipsFields } from 'modules/radio/RadioClipsFields';

function TVFields(): ReactElement {
  return (
    <>
      <TextField name="fields.clip_length" label="Clip length (seconds)" required />
      <h5 className="mt-3">Only for new clients</h5>
      <TextField name="fields.yearly_budget_by_group" label="Yearly budget by media group" />
      <TextField name="fields.agreed_prices" label="Agreed prices" />
    </>
  );
}

function RadioFields(): ReactElement {
  return (
    <div className="mb-3">
      <RadioClipsFields />
    </div>
  );
}

function WebFields(): ReactElement {
  return (
    <>
      <TextField name="fields.suggested_format" label="Suggested format" />
      <TextField name="fields.video" label="Video, clip length" />
      <TextField name="fields.mobile" label="Mobile" />
      <TextField name="fields.kpi" label="KPI" required multiline />
    </>
  );
}

function RTBFields(): ReactElement {
  return <TextField name="fields.kpi" label="KPI" required multiline />;
}

function SocialFields(): ReactElement {
  return (
    <>
      <TextField name="fields.website" label="Website" required />
      <div className="form-row form-group">
        <div className="col-md-4">
          <CheckField name="fields.public" fieldLabel="Public" variant="checkbox" />
        </div>
        <div className="col-md-6">
          <CheckField name="fields.indexed" fieldLabel="Indexed" variant="checkbox" />
        </div>
      </div>
      <div className="form-group position-relative">
        <label className="font-weight-bold">Requirements</label>
        <div className="form-row">
          <div className="col-md-4">
            <CheckField name="fields.audit" fieldLabel="Audit" variant="checkbox" />
          </div>
          <div className="col-md-6">
            <CheckField name="fields.consultations" fieldLabel="Consultations" variant="checkbox" />
          </div>
        </div>
      </div>
      <div className="form-group position-relative">
        <label className="font-weight-bold">On-site</label>
        <div className="form-row">
          <div className="col-md-4">
            <CheckField name="fields.meta_tags" fieldLabel="Meta tags" variant="checkbox" />
          </div>
          <div className="col-md-6">
            <CheckField name="fields.content" fieldLabel="Content" variant="checkbox" />
          </div>
        </div>
      </div>
      <div className="form-group position-relative">
        <label className="font-weight-bold">Off-site</label>
        <div className="form-row">
          <div className="col-md-4">
            <CheckField name="fields.backlinks" fieldLabel="Backlinks" variant="checkbox" />
          </div>
          <div className="col-md-6">
            <CheckField name="fields.articles" fieldLabel="Articles" variant="checkbox" />
          </div>
        </div>
      </div>
      <CheckField name="fields.reports" label="Reports" variant="checkbox" />
    </>
  );
}

const initialMaterial = {
  kind: '',
  amount: null,
};

function CreativeFields(): ReactElement {
  return (
    <>
      <div className="form-row">
        <DatePickerField
          name="fields.first_sketch"
          label="First sketch"
          className="col-md-4"
          required
          validate={required}
        />
      </div>
      <FormInline
        name="fields.materials"
        title="Describe required materials"
        addLabel="Add material"
        initialValues={initialMaterial}
        flush
      >
        {(name) => (
          <div className="form-row">
            <TextField placeholder="Material" name={`${name}.kind`} className="col-md-8" multiline size="sm" />
            <IntField name={`${name}.amount`} className="col-md-4" placeholder="Amount" size="sm" />
          </div>
        )}
      </FormInline>
      <TextField name="fields.styleguide" label="Style guidelines" help="Brandbook or any other materials" multiline />
      <TextField name="fields.copywrite" label="Copywrite" multiline />
      <div className="form-row">
        <TextField name="fields.website" label="Website" className="col-md-6" multiline />
        <TextField name="fields.social_media" label="Social media" className="col-md-6" multiline />
      </div>
    </>
  );
}

export const FIELD_MAP: Partial<Record<ActivityType, ComponentType>> = {
  TV: TVFields,
  RADIO: RadioFields,
  WEB: WebFields,
  RTB: RTBFields,
  SEO: SocialFields,
  CREATIVE: CreativeFields,
};
